import {EventBus} from "@/lib/event-bus/event-bus";

export default function clearError(request) {
    EventBus.$emit("goo-toasts.dismiss", "request-error");
    return request
}
